import { IDENTIFY } from '../constants'
import { HeapApi } from '~/lib/apis'
import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'
import logger from '~/lib/logger'

export default function (
    heapApi: HeapApi,
): Pick<AnalyticsHandlers, typeof IDENTIFY> {
    return {
        [IDENTIFY](payload) {
            // Bail out if we don't have a userId
            if (!payload.userId) {
                return
            }

            try {
                heapApi.identify(String(payload.userId))

                const userAttrs: Record<string, any> = {
                    fictiv_user_id: payload.userId,
                    email: payload.traits.email,
                }

                if (payload.isImpersonating) {
                    userAttrs.fictiv_true_user_id = payload.trueUserId
                }

                // Grab the Munchkin Id from the cookies
                const munchkinId = document.cookie.match(
                    new RegExp(`(^| )_mkto_trk=([^;]+)`),
                )

                if (munchkinId && munchkinId[2]) {
                    userAttrs.munchkin_id = munchkinId[2]
                }

                heapApi.addUserProperties(userAttrs)
            } catch (err) {
                logger.warn('Heap identify error')
            }
        },
    }
}
